<template>
  <div>
    <template v-if="bot.isLock">
      <v-badge :value="bot.isLock" overlap color="info" style="">
        <template #badge>
          <v-icon dark small>lock</v-icon>
        </template>
        <livechat-avatar :value="value" :bot="bot"></livechat-avatar>
      </v-badge>
    </template>
    <template v-else>
      <v-badge :value="totalUnreadMessage > 0" overlap color="#ff6565" style="">
        <template #badge>
          {{ totalUnreadMessage }}
        </template>
        <livechat-avatar :value="value" :bot="bot"></livechat-avatar>
      </v-badge>
    </template>
  </div>
</template>

<script>
import LivechatAvatar from './livechat-avatar.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    LivechatAvatar
  },
  props: ['value', 'bot'],
  data() {
    return {}
  },
  computed: {
    ...mapGetters({ getUnreadMessage: 'getUnreadMessage' }),
    totalUnreadMessage() {
      if (Object.hasOwnProperty.call(this.getUnreadMessage, this.bot.pageid)) {
        return this.getUnreadMessage[this.bot.pageid].total || 0
      }
      return 0
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-page-badge.vue